var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer-ring",style:(_vm.cssVariables)},[(_vm.selected)?_c('div',{staticClass:"inner-dot"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }